import { queryOptions, skipToken } from '@tanstack/react-query';
import { cmsQueryKeys } from '../cms/cmsQueryKeys';
import { getCMSPageContent } from '../cms/getCMSPageContent';
import type { PageSlugType } from '@/constants/page.constants';

export const pageContentQueryOptions = (pageKey: PageSlugType | null) =>
  queryOptions({
    queryKey: [cmsQueryKeys.getCMSPageContent[0], pageKey],
    queryFn: pageKey ? () => getCMSPageContent(pageKey) : skipToken,
    enabled: pageKey !== null,
    staleTime: Infinity,
  });
